import { styled } from '@mui/material/styles';

export const Wrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '200px',
  minWidth: '400px',
});

export const ContentContainer = styled('div')({
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '24px',
  maxWidth: '400px',
  width: '100%',
});

export const MessageText = styled('div')({
  textAlign: 'center',
  marginBottom: '8px',
});

export const ButtonsContainer = styled('div')({
  display: 'flex',
  gap: '12px',
  justifyContent: 'center',
  width: '100%',
}); 